import { httpInterceptor } from '../http-interceptor';

export class ForkliftService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getAllForkliftsNew',
    SAVE_NEW: 'Machine/saveNewForklift',
    UPDATE: 'Machine/saveNewForklift',
    DELETE: 'Machine/deleteForklift',
    SAVE_MAINTENANCE: 'Machine/SaveOrUpdateForkliftMaintenance',
    UPLOAD_DOCUMENT: 'Customer/Upload',
    GET_MAINTENANCE_RECORDS: 'Machine/getAllMaintenanceRecordsByForkliftId',
    GET_MAINTENANCE_RECORD_DETAILS: 'Machine/getForkliftMaintenanceRecordDetails',
    ADD_MAINTENANCE_RECORD: 'Machine/saveForkliftMaintenanceAllRecords',
    GET_BY_ASSET_NUMBER: 'Machine/getAllForkliftByAsstNo',
    GET_SAFETY_CHECKLIST_BY_FORKLIFT: 'Machine/forkliftSafetyChecklistByForklift',
    SAVE_SAFETY_CHECKLIST: 'Machine/saveOrUpdateForkliftSafetyChecklist',
    DELETE_SAFETY_CHECKLIST: 'Machine/deleteForkliftSafetyChecklist'
  };

  static async getAllForklifts(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async saveNewForklift(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_NEW, data);
  }

  static async updateForklift(data) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE, data);
  }

  static async deleteForklift(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async saveForkliftMaintenance(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MAINTENANCE, data);
  }

  static async uploadDocument(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, data);
  }

  static async getMaintenanceRecordsByForkliftId(forkliftId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORDS}/${forkliftId}`);
  }

  static async getMaintenanceRecordDetails(recordId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORD_DETAILS}/${recordId}`);
  }

  static async addMaintenanceRecord(data) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_MAINTENANCE_RECORD, data);
  }

  static async getAllForkliftByAssetNumber(assetNumber) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ASSET_NUMBER}/${assetNumber}`);
  }

  static async getForkliftSafetyChecklistByForklift(forkliftId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_SAFETY_CHECKLIST_BY_FORKLIFT}/${forkliftId}`,
    );
  }

  static async createForkliftSafetyChecklist(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_SAFETY_CHECKLIST, data);
  }

  static async deleteForkliftSafetyChecklist(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_SAFETY_CHECKLIST}/${id}`);
  }
}
